module.exports = __webpack_public_path__ + "img/blockS3-card1.d8617da6.svg";